module.exports = require("./es-CU.js");